<script setup lang="ts">
const { t } = useI18n();
const { sourcesUrl } = useRuntimeConfig().public;

useSeoMeta({
  title: "",
  description: `${t("main.marketplaceSEO.description.main")}`,
  ogType: "website",
  ogTitle: "GFAL Marketplace",
  ogDescription: `${t("main.marketplaceSEO.description.main")}`,
  ogUrl: "https://gfal.market",
  ogImage: sourcesUrl + "/images/marketplace.jpg",
  twitterCard: "summary_large_image",
  twitterSite: "@GFAL_Official",
  twitterTitle: "GFAL Marketplace",
  twitterDescription: `${t("main.marketplaceSEO.description.main")}`,
  twitterImage: sourcesUrl + "/images/marketplace.jpg",
});
</script>

<template>
  <div class="-mt-14">
    <HomeFeatured />
    <HomeGames />
  </div>
</template>
